export default {
  mainMenu: {
    en: 'Main menu',
  },
  help: {
    en: 'Help',
  },
  getFreeScent: {
    en: 'Get a Free Scent',
  },
  rateNeonHeatKit: {
    en: 'Rate Neon Heat Kit',
  },
  sendGift: {
    en: 'Send a Gift',
  },

  fathersDay: {
    en: 'Bamboo charcoal',
  },

  gifts: {
    en: 'All gifts',
  },
  giftCard: {
    en: 'Gift card',
  },
  giftSetsMen: {
    en: 'Gifts For Him',
  },
  giftSetsWomen: {
    en: 'Gifts For Her',
  },
  skincareSets: {
    en: 'Scentbird Gift Sets',
  },
  giftSubscription: {
    en: 'Gift subscription',
  },
  tracking: {
    en: 'Tracking',
  },
}
